import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../data/Axios/DynamicForm";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import { companyManagementUrl, setupManagementUrl } from "../../../config";
import { companyFields } from "../../../data/DynamicTable/CompanyManagementForms";
import { allSubscriptionPlans } from "../../../data/Axios/queries";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../../data/DynamicServiceNew/jsondynamicservice";

const base_url = companyManagementUrl.uri;
const setup_url = setupManagementUrl.uri;
const CompanyForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const [subscriptionsData, setSubscriptionsData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function fetchAllData() {
      try {
        const subscriptionsDataResponse = await fetchJsonDynamic(
          "allSubscriptionPlans",
          null,
          null,
          setup_url
        );
        if (subscriptionsDataResponse?.results) {
          const results = JSON.parse(subscriptionsDataResponse?.results);
          setSubscriptionsData(results || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchAllData();
  }, []);
  const subscriptionsOptions = subscriptionsData.map((subscriptions) => ({
    value: subscriptions.Id,
    label: subscriptions.PlanName,
  }));
  const isEditing = Boolean(props.isEditing || props.data?.Id || props.data?.id);

  const fields = [
    ...companyFields,
    {
      name: "company_Code",
      label: "Company Code",
      type: "text",
      gridColumn: "span 2",
      required: false,
      readonly: isEditing,
      readOnly: isEditing,
      disabled: isEditing,
      placeholder: isEditing ? "Company Code (Read-only)" : "Enter Company Code",
    },
    {
    name: "hasCallCenter",
    label: "Has Call Center",
    type: "checkbox",
    gridColumn: "span 2",
    required: false,
  },
    {
      name: "subscriptionId",
      label: "Subscription Plan",
      type: "select",
      options: subscriptionsOptions,
      gridColumn: "span 2",
      required: true,
    },
   

  ];
  const initialValues = {
    companyName: props.data ? props.data.CompanyName : "",
    contactPhoneNumber: props.data ? props.data.ContactPhoneNumber : "",
    parentOffice: props.data ? props.data.ParentOffice : "",
    contactPerson: props.data ? props.data.ContactPerson : "",
    postalAddress: props.data ? props.data.PostalAddress : "",
    senderId: props.data ? props.data.SenderId : "",
    apiKey: props.data ? props.data.ApiKey : "",
    fsApiKey: props.data ? props.data.FSApiKey : "",
    subscriptionId: props.data ? props.data.SubscriptionId : "",
    createdBy: props.data ? props.data.CreatedBy : userId,
    tagLine:props.data ? props.data.TagLine : "",
    hasCallCenter: props.data ? !!props.data.HasCallCenter : false,
    createdDate: props.data ? props.data.CreatedDate : new Date().toISOString(),
    updatedBy: userId,
    updatedDate: new Date().toISOString(),
    company_Code: props.data ? props.data.Company_Code : "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        companyName,
        subscriptionId,
        contactPhoneNumber,
        parentOffice,
        contactPerson,
        postalAddress,
        senderId,
        apiKey,
        fsApiKey,
        tagLine,
        hasCallCenter,
        company_Code
      } = values;
      const rawPhoneNumber = contactPhoneNumber?.toString()?.trim() || "";
      const cleanedPhoneNumber = rawPhoneNumber.replace(/\s+/g, "");
      const kenyanPhoneRegex = /^(?:(?:\+?254|0)[17]\d{8})$/;
      if (!kenyanPhoneRegex.test(cleanedPhoneNumber)) {
        Swal.fire({
          icon: "error",
          title: "Invalid Phone Number",
          text: "Please enter a valid Kenyan phone number in the format 254123456789, 0712345678, or +254712345678.",
          confirmButtonColor: "#d32f2f",
        });
        setSubmitting(false);
        return;
      }
      const formattedPhoneNumber = cleanedPhoneNumber.replace(/^\+/, "");
      const formattedfsapikey= fsApiKey ? fsApiKey.toString() : "";
      const mutationData = props.isEditing
        ? {
            id: props.data.Id,
            companyName,
            subscriptionId,
            contactPhoneNumber: formattedPhoneNumber,
            parentOffice,
            contactPerson,
            senderId,
            apiKey,
            fsApiKey: formattedfsapikey,
            postalAddress,
            updatedBy: userId,
            tagLine,
            hasCallCenter,
            company_Code
          }
        : {
            companyName,
            contactPhoneNumber: formattedPhoneNumber,
            parentOffice,
            contactPerson,
            postalAddress,
            senderId,
            apiKey,
            fsApiKey: formattedfsapikey,
            subscriptionId,
            createdBy: userId,
            tagLine,
            hasCallCenter,
            company_Code
          };

      const response = await executeAnyMutation(
        props.isEditing ? "updateCompany" : "createCompany",
        mutationData,
        props.isEditing ? "user" : "company",
        false,
        base_url
      );

      if (Object.values(response.results)) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Company ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };
  if (loading) {
    return <div className="justify-content-center">Loading...</div>;
  }
  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Company" : "Create Company"}
      subtitle={
        props.isEditing ? "Edit an Existing Company" : "Create a New Company"
      }
    />
  );
};

export default CompanyForm;
